import React from "react"
import { Row, Col, Container } from "reactstrap";
import { useHistory } from "react-router-dom";

const Footer = () => {

    return (
        <React.Fragment>
            <footer className="footer" style={{ backgroundColor: "#333333", color: "white", marginLeft: "-250px", width: "100%", padding: "0px", height: "40px" }}>
                <Container fluid={true}>
                    <Row>
                        <Col style={{ marginTop: "15px" }} md={6}> &copy; {new Date().getFullYear()} all rights reserved</Col>
                        <Col style={{ marginTop: "15px" }} md={6}>
                            <div className="text-sm-end d-none d-sm-block">
                                Powered by ZingWorks LLP
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer


